import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Loader from '../../components/Loader/Loader';
import useResourceEdit from '../../hooks/useResourceEdit';
import ResourceFormActions from '../../components/ResourceFormActions/ResourceFormActions';
import FuelDiscountForm from '../../components/forms/FuelDiscountForm/FuelDiscountForm';

export default function FuelDiscountEditContainer({
  id,
  handleCancel = () => {},
  onSave = () => {}
}) {
  const [state, attrs] = useResourceEdit({
    path: '/fuel_discounts',
    name: 'Fuel Discount',
    id,
    onSave
  });
  const { loading, data } = state;
  const { handleSubmit, setForm } = attrs;
  const [stores, setStores] = useState();

  // Run First Load
  useEffect(() => {
    axios.get(`/stores`).then((res) => setStores(res.data.records));
    return () => {
      setStores();
    };
  }, []);

  if (loading) {
    return <Loader display={true} />;
  }

  return (
    <React.Fragment>
      <FuelDiscountForm data={data} stores={stores} ref={(ref) => setForm(ref)} />
      <ResourceFormActions id={id} handleCancel={handleCancel} handleSubmit={handleSubmit} />
    </React.Fragment>
  );
}
